import { Entity } from '@inter-ikea-core/core';
import { Product } from '@inter-ikea-storageone/range';
import { isSelectedColorRequirementFulfilled } from './util';
import { getExistingSectionWidths } from '@inter-ikea-storageone/range-boaxel/src/api/functions/getExistingSectionWidths';

export const requiresSelectedColour = (products: Product[]) => {
  const matchingProducts = products.filter(product => isSelectedColorRequirementFulfilled(product));

  return matchingProducts;
};

export const matchExistingSectionWidths = (products: Product[], entitiesInScene: Entity[]) => {
  if (entitiesInScene.length === 0) return products;

  const widths = getExistingSectionWidths(entitiesInScene);
  return products.filter(p => widths.includes(p.communicatedDimensions.width));
};
